angular.module('aq.filters.formatters')
.filter('yesno', function() {
    return function(input) {
        return input ? 'yes' : 'no';
    }
});